import { Helmet } from "react-helmet";

const Title = ({ title }) => (
  <Helmet>
    <title>{title} - MatchingCore Console</title>
    <meta name="description" content="MatchingCore Console" />
  </Helmet>
);

export default Title;
